import { cmd, WebSocketServiceStubBase, WSStubResponse, WSSTUB_GENERIC_ERROR } from './web-socket-stub-base';

export class HWPortraitWebSocketStub extends WebSocketServiceStubBase {
  private cmdWaitingForBlob: string | null = null;

  override generateListOfCommands() {
    return [
      cmd('push-image').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('pop-image').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('copy').withDefaultResponse(),
      cmd('find-eyes').withCallback(this.responseFindEyes),
      cmd('set-eyes').withDefaultResponse(),
      cmd('crop').withDefaultResponse(),
      cmd('check-quality').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('binarize-signature').withDefaultResponse(),
      cmd('convert').withDefaultResponse(),
      cmd('clear').withDefaultResponse(),
      cmd('get-size').withCallback(this.responseGetSize),
      cmd('get-id').withCallback(this.responseGetId),
      cmd('HDR').withDefaultResponse(),
    ];
  }

  override onBlobReceived(data: Blob) {
    this.sendResponse(new WSStubResponse(this.cmdWaitingForBlob!));
    this.cmdWaitingForBlob = null;
  }

  private responseFindEyes(data: any) {
    this.sendResponse(
      new WSStubResponse(data.command, {
        left_x: 0,
        left_y: 0,
        right_x: 0,
        right_y: 0,
      }),
    );
  }

  private responseGetSize(data: any) {
    this.sendResponse(
      new WSStubResponse(data.command, {
        size: 0,
      }),
    );
  }

  private responseGetId(data: any) {
    this.sendResponse(
      new WSStubResponse(data.command, {
        id: '0xfb60a98',
      }),
    );
  }
}
